<!--
  @Description 人员导入
  @Date 2022-02-23
  @Author liushuo
-->
<template>
  <vxe-modal
    v-model="isShow"
    title="人员导入"
    width="80%"
    height="80%"
    @show="showWindows"
    mask-closable
    destroy-on-close
  >
    <vxe-toolbar>
      <template v-slot:buttons>
        <div>
          <input
            type="file"
            ref="uploadExcel"
            v-show="false"
            id="open"
            accept=".xls, .xlsx"
            @change="readExcel"
            v-if="resetExcel"
          />
          <el-input v-model="path" readonly size="mini" class="path-box"></el-input>
          <el-button @click="importExcel" type="primary" size="mini">选择文件</el-button>
          <el-button @click="handleSave" type="primary" size="mini">确认</el-button>
          <el-button @click="exportModule" type="primary" size="mini">导出模板</el-button>
        </div>
        <span> 导入格式为： 单位、部门、姓名、用户名、手机号、所在城市、角色、企业微信号、飞书账号、钉钉账号 </span>
        <br />
        <!-- <span style="color: red"
          >注意！如果有包含日期的列，请在excel中将此列的数据开头都加入一个单引号</span
        > -->
      </template>
    </vxe-toolbar>
    <div class="grid-box">
      <vxe-grid
        ref="xTable"
        highlight-hover-row
        highlight-current-row
        :data="tableData"
        keep-source
        resizable
        size="mini"
        :column-config="{ minWidth: '80px' }"
        :height="tableHeight"
        :cell-class-name="cellClassName"
        :edit-rules="validRules"
        :edit-config="{
          trigger: 'dblclick',
          mode: 'cell',
          activeMethod: activeMethod
        }"
        :keyboard-config="{
          isArrow: true,
          isEnter: true,
          isTab: true,
          enterToTab: true,
          isClip: true,
          isEdit: true,
          editMethod: editMethod
        }"
        :columns="gridColumns"
      >
      </vxe-grid>
    </div>
  </vxe-modal>
</template>

<script>
import { placeInfo } from '@/public/utils/globalVariable'
import { MessageBox } from 'element-ui'
export default {
  props: {
    parentObj: Object
  },
  data() {
    return {
      // 列头
      gridColumns: [],
      // 是否显示
      isShow: false,
      menuArgs: '',
      tableData: [],
      // 验证规则
      validRules: {},
      // 验证错误
      errIndex: [],
      path: '',
      resetExcel: true,
      // 区域数据
      areaList: []
    }
  },
  created() {
    this.InitColumn()
  },
  mounted() {},
  methods: {
    showWindows() {
      this.setRules()
      // 清空表格数据
      this.tableData = []
      // 清空文件名
      this.path = ''
    },
    // 初始化列头
    InitColumn() {
      let that = this
      that.gridColumns = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [
                  <el-tooltip class='tooltipItem' effect='light' content={row.repeatText} placement='right'>
                    <div style='width: 100%; height: 100%'>
                      <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                    </div>
                  </el-tooltip>
                ]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        },
        {
          field: 'delete',
          title: '删除',
          width: '50',
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.removeRowForTableAndData(row, this.$refs.xTable, this.$data)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          field: 'userCompany',
          title: '单位'
        },
        {
          field: 'deptName',
          title: '部门'
        },
        {
          field: 'name',
          title: '姓名'
        },
        {
          field: 'num',
          title: '用户名'
        },
        {
          field: 'tel',
          title: '手机号'
        },
        {
          field: 'city',
          title: '所在城市'
        },
        {
          field: 'roleName',
          title: '角色'
        },
        {
          field: 'weiXinID',
          title: '企业微信号'
        },
        {
          field: 'feiShuID',
          title: '飞书账号'
        },
        {
          field: 'dingDingID',
          title: '钉钉账号'
        }
      ]
    },
    // table 点击删除列，同时删除data中的数据
    removeRowForTableAndData(row, table) {
      MessageBox.confirm('确定要删除本行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          table.remove(row)
          // 删除 tableData 中的数据
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i]._XID === row._XID) {
              this.tableData.splice(i, 1)
              break
            }
          }
        })
        .catch(() => {})
    },
    setRules() {
      const that = this
      that.validRules = {
        userCompany: [
          { required: true, message: '请选择单位', trigger: 'change' },
          { validator: this.validUserCompany, trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '单位长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        deptName: [
          {
            min: 0,
            max: 16,
            message: '部门长度应在 0 到 16 个字符',
            trigger: 'change'
          }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          {
            min: 0,
            max: 5,
            message: '姓名长度应在 0 到 5 个字符',
            trigger: 'change'
          }
        ],
        num: [
          { required: true, message: '请输入用户名', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '用户名长度应在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        tel: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          {
            validator: this.validatePhone,
            message: '请输入正确电话号码',
            trigger: 'change'
          },
          {
            min: 0,
            max: 11,
            message: '手机号长度应在 0 到 11 个字符',
            trigger: 'change'
          }
        ],
        city: [
          { required: true, message: '请输入所在城市', trigger: 'change' },
          { validator: this.validCity, trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '所在城市长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        roleName: [
          { required: true, message: '请选择角色', trigger: 'change' },
          { validator: this.validRole, trigger: 'change' },
          {
            min: 0,
            max: 2,
            message: '角色长度应在 0 到 2 个字符',
            trigger: 'change'
          }
        ],
        weiXinID: [
          {
            min: 0,
            max: 64,
            message: '企业微信号长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        feiShuID: [
          {
            min: 0,
            max: 64,
            message: '飞书账号应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        dingDingID: [
          {
            min: 0,
            max: 64,
            message: '钉钉账号应在 0 到 64 个字符',
            trigger: 'change'
          }
        ]
      }
    },
    // 验证
    async validEnter() {
      let flag = true
      this.errIndex = []

      // 判断用户名是否重复
      this.repeatForTable(this.errIndex, this.$refs.xTable, ['num'])
      if (this.errIndex.length > 0) {
        flag = false
      }

      const isAllCheck = true
      const errMap = await this.$refs.xTable.fullValidate(isAllCheck).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
      }
      if (this.errIndex.length > 0) {
        flag = false
      }
      if (!flag) {
        this.$message.error('验证失败,请核对数据')
      }
      return flag
    },

    // 转换字符串
    transString(str) {
      return str ? str + '' : ''
    },
    importExcel() {
      this.resetExcel = false
      this.$nextTick(() => {
        this.resetExcel = true
      })
      this.$refs.uploadExcel.click()
    },
    // 导入excel
    readExcel(evnt) {
      let files = evnt.target.files
      if (files.length === 0) {
        return
      }
      this.path = files[0].name
      let fileReader = new FileReader()
      fileReader.onload = ev => {
        let data = ev.target.result
        let workbook = this.XLSX.read(data, { type: 'binary' })
        // 取第一张表
        const wsname = workbook.SheetNames[0]
        let ws = this.XLSX.utils.sheet_to_json(workbook.Sheets[wsname])
        let str = JSON.stringify(ws)
        str = str.replace(/（/g, '(')
        str = str.replace(/）/g, ')')
        ws = JSON.parse(str)

        this.tableData = []
        // 解析数据
        ws.forEach((value, index, ws) => {
          // 这里需要让tableData先push，才会有 _XID 供后续判断
          this.tableData.push({
            userCompany: this.transString(ws[index]['单位']),
            deptName: this.transString(ws[index]['部门']),
            name: this.transString(ws[index]['姓名']),
            num: this.transString(ws[index]['用户名']),
            tel: this.transString(ws[index]['手机号']),
            city: this.transString(ws[index]['所在城市']),
            roleName: '客户',
            weiXinID: this.transString(ws[index]['企业微信号']),
            feiShuID: this.transString(ws[index]['飞书账号']),
            dingDingID: this.transString(ws[index]['钉钉账号'])
          })
        })
      }
      fileReader.readAsBinaryString(files[0])
    },
    // 对数据和模块菜单进行匹配
    // async matchMenu (importData) {
    //   const { data: res } = await this.$http.post('/Common/YKCase/excelcreate', importData)
    //   if (!res.isSuccess) {
    //     this.$message.error(res.errorMessage)
    //     return false
    //   }
    //   // 对未关联的数据进行报错提示
    //   const errorLength = this.setErrorIndex(importData, res.data)
    //   if (errorLength > 0) {
    //     this.$message.warning('有未关联到基础设置的数据')
    //   }
    // },
    /**
     * 对未关联的数据进行报错提示
     * @param {Object} importData 导入时的所有数据
     * @param {Object} resData 关联得上的行数据
     */
    setErrorIndex(importData, resData) {
      // 将表格数据置空，重新赋值
      this.tableData = []

      let oldXIDMap = new Map()
      let newXIDMap = new Map()

      for (let oldItem of importData) {
        let isHas = false
        oldXIDMap.set(oldItem._XID, true)

        for (let newItem of resData) {
          if (oldItem._XID === newItem._XID) {
            // 如果id有相等，说明关联得到，追加 newItem，标记并退出
            this.tableData.push(newItem)
            isHas = true
            newXIDMap.set(newItem._XID, true)
            break
          }
        }

        // 如果标记为false，说明未关联得到，则追加 oldItem
        if (!isHas) {
          this.tableData.push(oldItem)
        }
      }

      oldXIDMap.forEach((value, key) => {
        if (!newXIDMap.has(key)) {
          const XID = key
          this.errIndex.push({
            _XID: XID,
            ifRepeat: true,
            columnIndex: 0
          })
        }
      })
      return this.errIndex.length
    },
    // 确认值
    async handleSave() {
      const that = this
      this.validEnter().then(async result => {
        if (result) {
          let tableData = [...that.tableData]
          tableData = that.removeArrayNull(tableData)
          that.$emit('sureImportBack', tableData)
          that.$nextTick(() => {
            that.isShow = false
          })
        }
      })
    },
    // cell激活控制
    // params: { column, columnIndex }
    activeMethod() {
      return true
    },
    // cell编辑控制
    // { row, rowIndex, column, columnIndex, cell }
    editMethod() {
      return true
    },
    // 单元格设置样式,错误提示
    // { row, rowIndex, column, columnIndex }
    cellClassName({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // 导出模板
    exportModule() {
      this.$refs.xTable.exportData({
        type: 'xlsx',
        // 过滤序号列
        columnFilterMethod: ({ column }) => {
          if (column.type === 'seq' || column.property === 'delete') {
            return false
          }
          return true
        }
      })
    },
    validRepeat(errIndex, table) {
      let isRepeat = false
      let repeatRowIndex = -1
      const tableData = table.getTableData().fullData
      // 用于存放不重复行的数据，拼接的字符串值作为 key，行索引作为 value
      const mapObj = new Map()

      // 重复行 | 分标编号、货物类别、包号、项目单位、投标人名称
      for (let [oldRowIndex, item] of tableData.entries()) {
        let cachekey =
          (item.subjectNum ? item.subjectNum : '') +
          '|' +
          (item.goodsType ? item.goodsType : '') +
          '|' +
          (item.package ? item.package : '') +
          '|' +
          (item.projectOwner ? item.projectOwner : '') +
          '|' +
          (item.bidder ? item.bidder : '')
        cachekey === '' && (cachekey = 'null')

        // 没有重复行，则将当前行数据添加进 map
        if (!mapObj.has(cachekey)) {
          mapObj.set(cachekey, oldRowIndex)
          continue
        }

        // 有重复行
        repeatRowIndex = mapObj.get(cachekey)
        item.ifRepeat = true
        item.repeatText = `与第${repeatRowIndex + 1}行数据重复`
        if (repeatRowIndex >= 0) {
          errIndex.push({
            _XID: item._XID,
            columnIndex: 0,
            repeatRowIndex: repeatRowIndex
          })
        }
        isRepeat = true
      }
      return isRepeat
    },

    // 前端不能与技术测试、业务测试相同
    validatePersonFront({ cellValue, row }) {
      return new Promise((resolve, reject) => {
        if (cellValue === '' || cellValue === '/' || cellValue == null) {
          resolve()
        } else if (row['frontEngineer'] === row['techTester'] || row['frontEngineer'] === row['businessTester']) {
          reject(new Error('研发不能同时作为测试人员'))
        } else {
          resolve()
        }
      })
    },
    // 后端不能与技术测试、业务测试相同
    validatePersonBack({ cellValue, row }) {
      return new Promise((resolve, reject) => {
        if (cellValue === '' || cellValue === '/' || cellValue == null) {
          resolve()
        } else if (row['backEngineer'] === row['techTester'] || row['backEngineer'] === row['businessTester']) {
          reject(new Error('研发不能同时作为测试人员'))
        } else {
          resolve()
        }
      })
    },
    // 技术测试不能与前端研发、后端研发相同
    validatePersonTech({ cellValue, row }) {
      return new Promise((resolve, reject) => {
        if (cellValue === '' || cellValue === '/' || cellValue == null) {
          resolve()
        } else if (row['techTester'] === row['backEngineer'] || row['techTester'] === row['frontEngineer']) {
          reject(new Error('测试不能同时作为研发人员'))
        } else {
          resolve()
        }
      })
    },
    // 业务测试不能与前端研发、后端研发相同
    validatePersonBus({ cellValue, row }) {
      return new Promise((resolve, reject) => {
        if (cellValue === '' || cellValue === '/' || cellValue == null) {
          resolve()
        } else if (row['businessTester'] === row['backEngineer'] || row['businessTester'] === row['frontEngineer']) {
          reject(new Error('测试不能同时作为研发人员'))
        } else {
          resolve()
        }
      })
    },
    // 校验城市名字有效性
    validCity({ cellValue }) {
      return new Promise((resolve, reject) => {
        let root = placeInfo[0]
        // 广度优先遍历
        const bfs = root => {
          // 根节点入队
          let q = [root]
          while (q.length > 0) {
            // 根节点出队并访问
            const n = q.shift()
            if (n.value === cellValue) {
              return true
            }
            n.children?.forEach(child => {
              q.push(child)
            })
          }
          return false
        }

        bfs(root) ? resolve() : reject(new Error('请输入有效的城市'))
      })
    },
    // 校验角色有效性
    validRole({ cellValue }) {
      // 有效值域为 [客户、管理、运维]
      let validRole = ['客户', '管理', '运维']
      return new Promise((resolve, reject) => {
        if (validRole.includes(cellValue)) {
          resolve()
        } else {
          reject(new Error('请输入有效的角色（客户、管理、运维）'))
        }
      })
    },
    // 校验单位名有效性
    validUserCompany({ cellValue }) {
      let validUserCompany = this.$parent.userCompanyList
      return new Promise((resolve, reject) => {
        if (validUserCompany.includes(cellValue)) {
          resolve()
        } else {
          reject(new Error('请输入有效的单位名称'))
        }
      })
    }
  },
  computed: {
    tableHeight() {
      if (this.isShow) {
        return this.$store.state.clientHeight * 0.8 - 140 + 'px'
      } else {
        return '100px'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.path-box {
  width: 50%;
  margin-right: 20px;
}
.vxe-toolbar {
  display: flex;
  align-items: flex-start;
  height: 60px;
}

// 验证的红色提示框，字多会换行
// /deep/ .vxe-cell--valid {
//   width: 320px !important;
// }
</style>
